import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IAccountByEmployee } from "src/models/HumanResources/AccountsByEmployee.models";

interface AccountByEmployeeState {
  accountsByEmployee: IAccountByEmployee[];
  accountByEmployeeToEdit: IAccountByEmployee | null;
}

const initialState: AccountByEmployeeState = {
  accountsByEmployee: [],
  accountByEmployeeToEdit: null,
};

const AccountByEmployeeSlice = createSlice({
  name: "AccountByEmployee",
  initialState,
  reducers: {
    setAccountByEmployeeList: (
      state,
      action: PayloadAction<IAccountByEmployee[]>
    ) => {
      state.accountsByEmployee = action.payload;
    },
    concatListAccountByEmployee: (
      state: AccountByEmployeeState,
      action: PayloadAction<IAccountByEmployee[]>
    ) => {
      state.accountsByEmployee = [
        ...state.accountsByEmployee.concat(action.payload),
      ];
    },
    setAccountByEmployeeToEdit: (
      state,
      action: PayloadAction<IAccountByEmployee | null>
    ) => {
      state.accountByEmployeeToEdit = action.payload;
    },
    addAccountByEmployee: (
      state,
      action: PayloadAction<IAccountByEmployee>
    ) => {
      // console.log("addAccountByEmployee", action.payload);
      // console.log(
      //   "addAccountByEmployee Before",
      //   state.accountsByEmployee.values
      // );
      // state.accountsByEmployee.push(action.payload);
      // console.log(
      //   "addAccountByEmployee After",
      //   state.accountsByEmployee.values
      // );

      // Crear una copia del array existente y agregar el nuevo item
      const updatedDocuments = [...state.accountsByEmployee, action.payload];

      // Actualizar el estado con la nueva copia del array
      state.accountsByEmployee = updatedDocuments;
    },
    updateAccountByEmployee: (
      state,
      action: PayloadAction<IAccountByEmployee>
    ) => {
      let itemIndex = state.accountsByEmployee.findIndex(
        item =>
          item.accountByEmployeeId === action.payload.accountByEmployeeId &&
          item.accountTypeId === action.payload.accountTypeId &&
          item.bankId === action.payload.bankId
      );

      if (itemIndex !== -1)
        state.accountsByEmployee[itemIndex] = action.payload;
    },
    deleteAccountByEmployee: (
      state,
      action: PayloadAction<IAccountByEmployee>
    ) => {
      const newArray = state.accountsByEmployee.filter(
        item =>
          !(
            item.accountNumber === action.payload.accountNumber &&
            item.accountTypeId === action.payload.accountTypeId &&
            item.bankId === action.payload.bankId
          )
      );
      state.accountsByEmployee = newArray;
    },
  },
});

export const {
  setAccountByEmployeeList,
  concatListAccountByEmployee,
  setAccountByEmployeeToEdit,
  addAccountByEmployee,
  updateAccountByEmployee,
  deleteAccountByEmployee,
} = AccountByEmployeeSlice.actions;

export default AccountByEmployeeSlice.reducer;
